import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { KUTCResultEntry } from './kutcResultsService';
import { duvWorkbookData, DuvSection, DuvSettings } from '../utils/kutcDuvExport';

export async function loadKutcDuvTotals(editionId: string): Promise<KUTCResultEntry[]> {
  if (!/^kutc-\d{4}$/.test(editionId)) throw new Error('Velg én KUTC-årsutgave.');
  const snapshot = await getDocs(collection(db, 'kutcResults', editionId, 'races', 'total', 'results'));
  return snapshot.docs.map(document => {
    const data = document.data();
    if (!/^\d+$/.test(document.id) || (data.personId != null && Number(data.personId) !== Number(document.id))) {
      throw new Error('Motstridende person-ID i totalresultatene.');
    }
    return { ...data, personId: Number(document.id) } as KUTCResultEntry;
  });
}
export async function downloadKutcDuvResults(settings: DuvSettings, sections: DuvSection[], resultsStatus: string, isCurrent: () => boolean = () => true): Promise<void> {
  if (resultsStatus.trim().toLowerCase() !== 'final') throw new Error('DUV-eksport krever endelige resultater (final).');
  if (sections.length !== 1) throw new Error('Velg én distanse eller Last One Standing per fil.');
  const sectionId = sections[0].id;
  if (!/^(?:[1-9]\d*-loops|last-one-standing)$/.test(sectionId)) throw new Error('Ugyldig distanse.');
  const data = duvWorkbookData(settings, sections);
  const { default: writeExcelFile } = await import('write-excel-file/browser');
  if (!isCurrent()) throw new Error('Årsutgaven er endret. Start eksporten på nytt.');
  await writeExcelFile(data, { sheet: 'DUV Results', columns: [12, 25, 25, 10, 15, 14, 20, 16, 8, 16, 20, 20, 20, 16, 30, 55].map(width => ({ width })) }).toFile(`${settings.editionId}_${sectionId}_DUV.xlsx`);
}
